// @flow
import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog';
import AutoMessageSftpCredentialsActions from 'admin/actions/AutoMessageSftpCredentialsActions';

export default function AdminAutoMessageSftpCredentialsConfirmDeleteDialog(props: {
  onRequestHide: () => void,
  onConfirm?: () => void,
  orgUuid: string,
  username: string,
}) {
  return (
    <ConfirmDialog
      data-test="delete-credentials-confirm-dialog"
      title="Are you sure you want to delete these credentials?"
      actionButtonText="Delete"
      actionButtonColor="apple"
      cancelButtonText="Cancel"
      cancelButtonColor="apple"
      onRequestHide={props.onRequestHide}
      onConfirm={() => {
        const { username, orgUuid } = props;
        AutoMessageSftpCredentialsActions.revokeAutoMessageSftpCredentials(
          username,
          orgUuid,
          props.onConfirm
        );
      }}>
      Remind will stop receiving the files transferred using these credentials. Auto messages
      dependent on these files will stop sending.
    </ConfirmDialog>
  );
}
